import { Liga } from './liga';

export enum TipoPessoa {
  PESSOA_FISICA = 'PESSOA_FISICA',
  PESSOA_JURIDICA = 'PESSOA_JURIDICA',
}

export enum TipoConta {
  CORRENTE = 'CORRENTE',
  POUPANCA = 'POUPANCA',
}

export interface LigaContaIugu {
  id: string;
  liga?: Liga | null;
  accountId?: string | null;
  nome: string;
  verificada: boolean;
  ativa: boolean;
  criadoEm: string;
  atualizadoEm?: string | null;
}

export interface LigaContaIuguDocumentos {
  id: string;
  liga?: Liga | null;
  tipoPessoa: TipoPessoa;
  cnpj?: string | null;
  cpf?: string | null;
  nomeEmpresa?: string | null;
  nomeResp?: string | null;
  respCpf?: string | null;
  nome?: string | null;
  endereco?: any | null;
  telefone?: string | null;
  banco?: string | null;
  bancoAg?: string | null;
  tipoConta?: TipoConta | null;
  bancoCc?: string | null;
  arquivoIdUrl?: string | null;
  selfieUrl?: string | null;
  comprovanteEnderecoUrl?: string | null;
  relatorioFinanceiroUrl?: string | null;
  contratoSocialUrl?: string | null;
  priceRange?: string | null;
  physicalProducts?: boolean | null;
  businessType?: string | null;
  automaticTransfer?: boolean | null;
  estimatedRevenue?: string | null;
  criadoEm: string;
  atualizadoEm?: string | null;
}

export interface LigaContaIuguInput {
  ligaId: string;
  accountId?: string | null;
  nome: string;
  verificada?: boolean | null;
  ativa?: boolean | null;
}

export interface LigaContaIuguDocumentosInput {
  ligaId: string;
  tipoPessoa: TipoPessoa;
  cnpj?: string | null;
  cpf?: string | null;
  nomeEmpresa?: string | null;
  nomeResp?: string | null;
  respCpf?: string | null;
  nome?: string | null;
  enderecoId?: string | null;
  telefone?: string | null;
  banco?: string | null;
  bancoAg?: string | null;
  tipoConta?: TipoConta | null;
  bancoCc?: string | null;
  arquivoIdUrl?: string | null;
  selfieUrl?: string | null;
  comprovanteEnderecoUrl?: string | null;
  relatorioFinanceiroUrl?: string | null;
  contratoSocialUrl?: string | null;
  priceRange?: string | null;
  physicalProducts?: boolean | null;
  businessType?: string | null;
  automaticTransfer?: boolean | null;
  estimatedRevenue?: string | null;
}
